<template>
  <v-container id="contratos-jugador" fluid tag="section">
    <v-row justify="end" class="mb-3">
      <v-btn v-if="$can('M_contratos_crear')" color="#ac8a2e" dark @click="goToNewContratoForm('new', 0, 0)">
        Agregar contrato
      </v-btn>
    </v-row>
    <v-row>
      <v-expansion-panels :value="0">
        <v-expansion-panel>
          <v-expansion-panel-header>
            Contratos Vigentes
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <contratos-tabla :key="rerenderV" url="/api/contrato_vigentes" @change="actualizar" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Contratos Futuros
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <contratos-tabla url="/api/contrato_futuros" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Contratos Cerrados
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <contratos-tabla :key="rerenderA" url="/api/contrato_anteriores" :can-edit="false" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import ContratosTabla from '../pages/components/ContratosTabla'

  export default {
    components: {
      ContratosTabla,
    },
    props: {
      idJugador: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data () {
      return {
        rerenderV: 1,
        rerenderA: 10,
      }
    },
    created () {
    },
    methods: {
      showItem (item) {
        this.goToNewContratoForm('show', item.id, item.jugador_id)
      },
      goToNewContratoForm (modeVal, IdContrato, idJugador) {
        this.$router.push({ name: 'Alta Contrato', params: { mode: modeVal, idJugador: idJugador, idContrato: IdContrato } })
      },
      actualizar () {
        this.rerenderV += 1
        this.rerenderA += 1
      },
    },
  }
</script>
